<template>
    <div class="auth-page text-dark">
        <CRow>
            <CCol sm="12" class="d-flex align-items-center justify-content-center min-vh-100 bg-white">
                <CContainer class="auth-container">
    
                    <!-- Tabs -->
                    <div class="auth-tabs text-center mb-4">
                        <button :class="['tab-btn', { active: activeTab === 'login' }]" @click="activeTab = 'login'">
                        Login
                      </button>
                        <button :class="['tab-btn', { active: activeTab === 'register' }]" @click="activeTab = 'register'">
                        Register
                      </button>
                    </div>
    
                    <!-- Login Section -->
                    <div v-if="activeTab === 'login'">
                        <h3 class="auth-title">Welcome back!</h3>
                        <p class="auth-subtitle">Enter your email address and password to login</p>
    
                        <CAlert v-if="ErrorLogin" show color="danger">
                            <strong>Error!</strong> {{ Message }}
                        </CAlert>
    
                        <div class="mt-3">
                            <label>Email</label>
                            <input type="text" class="custom-input-app mb-3" v-model="userEmail" />
                            <label>Password</label>
                            <input type="password" class="custom-input-app mb-4" v-model="userPassword" />
                        </div>
    
                        <CButton class="custom-border-purple p-2 text-white" block size="lg" @click="trylogin">
                            Login
                        </CButton>
    
                        <p class="text-center mt-3">
                            <span class="font-color-101010" @click="OpenForgot">Forgot Password?</span>
                        </p>
                    </div>
    
                    <!-- Register Section -->
                    <div v-else>
                        <h3 class="auth-title">Sign Up</h3>
                        <p class="auth-subtitle">It only takes a minute to create your account</p>
    
                        <CAlert v-if="ErrorRegister" show color="danger">{{ Message }}</CAlert>
    
                        <label>Full Name</label>
                        <input v-model="name" type="text" class="custom-input-app mb-2" />
    
                        <label>Email</label>
                        <input v-model="email" type="text" class="custom-input-app mb-2" />
    
                        <label>Phone Number</label>
                        <input v-model="phoneNo" type="text" class="custom-input-app mb-2" />
    
                        <label>Password</label>
                        <input v-model="password" type="password" class="custom-input-app mb-2" />
    
                        <label>Confirm Password</label>
                        <input v-model="confirmPassword" type="password" class="custom-input-app mb-3" />
    
                        <CButton class="custom-border-purple p-2 text-white" block size="lg" :disabled="!passwordValid" @click="registerAccount">
                            Create Account
                        </CButton>
                    </div>
    
                    <!-- Divider -->
                    <img src="../assets/img/or1.png" class="divider mt-4 mb-3" />
    
                    <!-- Google Sign In -->
                    <div id="g_id_signin" class="text-center mt-2"></div>
    
                    <div class="text-center mt-4">
                        <p class="custom-18px-500">
                            {{ activeTab === 'login' ? "Don’t have an account?" : "Already have an account?" }}
                            <span class="font-color-928AFD cursor-pointer" @click="toggleTab">
                          {{ activeTab === 'login' ? "Create Account" : "Login" }}
                        </span>
                        </p>
                    </div>
                </CContainer>
            </CCol>
        </CRow>
    </div>
</template>
  
<script>
import Vue from "vue";
//import GAuth from "vue-google-oauth2";


export default {
    name: "AuthPage",
    props: {
    sessionId: {
      type: String,
      required: false,
      default: ""
    }
  },
    data() {
        return {
            activeTab: "login",
            userEmail: "",
            userPassword: "",
            name: "",
            email: "",
            phoneNo: "",
            password: "",
            confirmPassword: "",
            ErrorLogin: false,
            ErrorRegister: false,
            Message: "",
        };
    },
    computed: {
        passwordValid() {
            return (
                this.password.length >= 8 &&
                this.password === this.confirmPassword
            );
        },
    },
    mounted() {
        this.loadGoogleScript();
    },
    methods: {
        toggleTab() {
            this.activeTab = this.activeTab === "login" ? "register" : "login";
        },
        trylogin() {
    if (!this.userEmail || !this.userPassword) {
        this.ErrorLogin = true;
        this.Message = "Please fill in all fields!";
        return;
    }

    const formData = new FormData();
    formData.append("email", this.userEmail);
    formData.append("password", this.userPassword);
    if (this.sessionId) formData.append("sessionId", this.sessionId);

    this.$API.post(this.$LoginTokenQR, formData, { withCredentials: true })
        .then((response) => {
            console.log("Login response:", response.data);

            if (response.data.status === 400) {
                this.ErrorLogin = true;
                this.Message = response.data.message;
                return;
            }

            if (response.status === 200 && response.data.data && response.data.data.userId) {
            this.user = {
                id: response.data.data.userId,
                type: response.data.data.userType
            };
            console.log("User after login:", this.user);

            this.showLoginPopup = false;

            this.InsertPoint(); // Now it will run

            this.$emit('login-success');
        } else {
            this.ErrorLogin = true;
            this.Message = response.data.message || "Login failed";
        }
                })
                .catch((error) => {
                    this.ErrorLogin = true;
                    this.Message = error.response?.data?.message || "Something went wrong";
                });
        },
        registerAccount() {
            if (!this.passwordValid) {
                this.ErrorRegister = true;
                this.Message = "Passwords do not match or invalid!";
                return;
            }

            if (this.name === "" || this.email === "" || this.password === "") {
                this.ErrorRegister = true;
                this.Message = "Please fill up the form !";
                return;
            }

            const formData = new FormData();
            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("phone", this.phoneNo);
            formData.append("userType", "candidate");
            formData.append("password", this.password);
            formData.append("website", "");
            formData.append("detail", "");
            formData.append("countryId", 46);
            if (this.sessionId) formData.append("sessionId", this.sessionId);

            this.$API
                .post(this.$RegisterQR, formData, { withCredentials: true })
                .then((response) => {
                    console.log("Register response:", response.data); // 🔥 Log it
                    const userId = response.data.data?.userId || response.data.userId;

                    if (response.status === 200 && userId) {
                        this.user = {
                            id: userId,
                            type: response.data.data?.userType || response.data.userType
                        };

                        console.log("User after register:", this.user);

                        this.InsertPoint(); // ✅ Now it will run

                        this.$emit('login-success');
                    } else {
                        this.ErrorRegister = true;
                        this.Message = response.data.message || "Register failed";
                    }
                })
                .catch((error) => {
                    this.ErrorRegister = true;
                    this.Message = error.response?.data?.message || "Something went wrong";
                });
        },
        OpenForgot() {
            this.$router.push("ForgotPassword");
        },
        loadGoogleScript() {
            if (!window.google) {
                const script = document.createElement("script");
                script.src = "https://accounts.google.com/gsi/client";
                script.async = true;
                script.defer = true;
                script.onload = this.initGoogleSignIn;
                document.head.appendChild(script);
            } else {
                this.initGoogleSignIn();
            }
        },
        initGoogleSignIn() {
            window.google.accounts.id.initialize({
                client_id: "20319378015-mf0mi472v5n6i9926q0nkgf6jqrj9tgv.apps.googleusercontent.com",
                callback: this.handleGoogleLogin,
            });
            window.google.accounts.id.renderButton(document.getElementById("g_id_signin"), {
                theme: "outline",
                size: "large",
                width: "100%",
            });
        },
        handleGoogleLogin(response) {
  console.log("Google login success:", response);

  const googleToken = response.credential;
  const formData = new FormData();
  formData.append("idToken", googleToken);
  if (this.sessionId) formData.append("sessionId", this.sessionId);

  this.$API.post(this.$LoginTokenQR, formData, { withCredentials: true })
    .then((res) => {
      console.log("Google login response:", res.data);

      if (res.status === 200 && res.data.data && res.data.data.userId) {
        this.user = {
          id: res.data.data.userId,
          type: res.data.data.userType,
        };

        this.showLoginPopup = false;
        this.InsertPoint();
        this.$emit("login-success");
      } else {
        this.ErrorLogin = true;
        this.Message = res.data.message || "Login failed";
      }
    })
    .catch((err) => {
      this.ErrorLogin = true;
      this.Message = err.response?.data?.message || "Something went wrong";
    });
},
        InsertPoint() {
    if (!this.user || !this.user.id) {
        console.error("Cannot insert points: user.id missing", this.user);
        return;
    }

    const formData = new FormData();
    formData.append("userId", this.user.id);
    formData.append("sessionId", this.sessionId || "");

    console.log("Inserting point for:", this.user.id, this.sessionId);

    this.$API.post(this.$InsertUserPoint, formData)
        .then((response) => {
            console.log("InsertPoint response:", response);
            if (response.status === 200) {
                this.showThanksModal = true;
                setTimeout(() => this.showThanksModal = false, 3000);
            } else {
                console.warn("InsertPoint failed", response);
            }
        })
        .catch((error) => {
            console.error("InsertPoint error:", error);
        });
}
    },
};
</script>
  
<style scoped>
.auth-container {
    max-width: 480px;
    text-align: left;
}

.auth-tabs {
    display: flex;
    justify-content: center;
    gap: 20px;
}

.tab-btn {
    background: none;
    border: none;
    font-weight: 600;
    font-size: 18px;
    color: #9da4ae;
    cursor: pointer;
    transition: color 0.3s;
}

.tab-btn.active {
    color: #5b43ff;
    border-bottom: 3px solid #5b43ff;
}

.auth-title {
    font-size: 24px;
    font-weight: 600;
    color: #171717;
}

.auth-subtitle {
    color: #9da4ae;
    font-size: 16px;
}

.divider {
    max-width: 100%;
}

.cursor-pointer {
    cursor: pointer;
}

@media (max-width: 768px) {
    .auth-container {
        padding: 20px;
    }
    .auth-title {
        font-size: 20px;
    }
    .tab-btn {
        font-size: 16px;
    }
}
</style>